export * from "./feed-icon.component";
